import React from "react";
import i18n from "../../../../../utils/ChrI18n";

/*
props = {
  customControlComponent
  elements = [<components>,...]
  horizontalEllipsis
}
*/

export const handleKeyDown = event => {
  if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    event.target.click();
  }
}

export const dropdownControlComponentProps = {
  "data-toggle": 'dropdown',
  tabIndex: 0,
  onKeyDown: handleKeyDown,
  role: "button",
  "aria-haspopup": true,
  "aria-expanded": false,
  "aria-controls": "dropdownMenu"
}

const EllipsisControlComponent = (props) => (
  <i
    className={ `fa-regular fa-ellipsis-${ props.horizontalEllipsis ? "h" : "v" } fa-lg ${props.disabled ? 'invisible' : 'cursor-pointer'} ${props.iconClass}` }
    title={i18n.t('display_string.Actions')}
    aria-label={i18n.t('display_string.Actions')}
    aria-disabled={props.disabled}
    {...dropdownControlComponentProps}
    tabIndex={props.disabled ? -1 : dropdownControlComponentProps.tabIndex}
    onKeyDown={props.disabled ? undefined : dropdownControlComponentProps.onKeyDown}
  />
)

const ChrEllipsisDropdown = props => {
  const elements = props.elements;

  return (
    <div className='dropdown'>
      { props.customControlComponent ? props.customControlComponent : <EllipsisControlComponent {...props} /> }
      {
        !props.disabled && (
          <ul role="menu" aria-labelledby="dropdownButton" className={ `dropdown-menu dropdown-menu-right ${props.dropdownMenuClass}` }>
          {
            elements.map((element, index) => {
              return (
                <li className='dropdown-item' key={ index }>
                  { element }
                </li>
              )
            })
          }
          </ul>
        )
      }
    </div>
  )
}

export default ChrEllipsisDropdown;
